import { defineStore } from 'pinia'
import { ref, watchEffect } from 'vue'
import type { AdminServiceType } from './types'
import { useLoadCabinetAdminServices } from './../model/api'
import { cloneDeep } from 'lodash'

const useModel = defineStore('cabinet_admin_services', () => {
  const serviceTab = ref('mqtt')

  const cabinet = ref<AdminServiceType | null>({
    serial_number: '',
    contactor_count: 6,
    pe_status: null,
    switching_logic: [],
  })

  const brokers = ref<any[]>([])

  const loadData = () => {
    const result = useLoadCabinetAdminServices()

    watchEffect(() => {
      if (result.data.value) {
        cabinet.value = cloneDeep(result.data.value.data)
        brokers.value = result.data.value.payload.mqtt_brokers
      }
    })

    return result
  }

  return {
    serviceTab,
    cabinet,
    brokers,

    loadData,
  }
})

export default useModel
